import { gql } from '@apollo/client'
import { TENANT_CONTACTS_FRAGMENT } from '../fragments/tenant.fragment'

export const GET_APP_INIT_QUERY = gql`
	query getAppInit {
		appInit {
			tenantContacts {
				...tenantContactsFragment
			}
		}
	}
	${TENANT_CONTACTS_FRAGMENT}
`
